import React, { useState } from 'react';
import { useField, useFormikContext } from 'formik';
import { UploadImgIcon, ChooseFileIcon, RemoveIcon } from 'Assets/icons'; // Assuming these icons are available
import { useUploadFileMutation } from "store/services/utility";
import LoadingIndicator from "../LoadingIndicator";

const AppProfilePictureField = ({ name, label, allowedTypes = [], acl, ...props }) => {
  const { setFieldValue, values } = useFormikContext();
  const [field, meta] = useField(name);
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [customError, setCusomError] = useState(null);

  const handleFileChange = async (event) => {
    try {
      const file = event.currentTarget.files[0];
      if (file) {
        if (allowedTypes.length && !allowedTypes.includes(file.type)) {
          setCusomError(`Only ${allowedTypes?.map(i => i)?.join()?.replace(/,/g, " , ")} format is allowed`);

          // alert('File type not allowed.');
          return;
        }
        setCusomError(null);
        const response = await uploadFile({ file, acl });
        if (!response?.error) {
          setFieldValue(name, response?.data); // Update Formik field value
          setUploadedFileName(file.name); // Store the uploaded file name
        }
      }
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };

  const handleRemoveFile = () => {
    setUploadedFileName(null);
    setFieldValue(name, ""); // Clear Formik field value
  };

  return (
    <>
      {!values[name] ? (
        <div className="d-flex align-items-center gap-10">
          <div
            className="position-relative rounded-circle flex-shrink-0"
            style={{
              background: "#F4F4F4",
              height: 100,
              width: 100,
            }}
          >
            <input
              name={name}
              type="file"
              className="file position-absolute h-100 w-100 rounded-circle"
              style={{
                left: 0,
                top: 0,
                zIndex: 9,
                cursor: "pointer",
              }}
              onChange={handleFileChange}
              disabled={isUploading}
              {...props}
            />
            <div className="h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
              <UploadImgIcon />
            </div>
            <span
              className="icn position-absolute"
              style={{ right: 5, bottom: 0 }}
            >
              <ChooseFileIcon />
            </span>
            {isUploading && (
              <span
                className="icn position-absolute"
                style={{ right: 30, bottom: 40 }}
              >
                <LoadingIndicator inline />
              </span>
            )}
          </div>
          <label htmlFor={name} className="form-label themeBlue fw-bold mb-0">
            {label}
          </label>
        </div>
      ) : (
        <div className="d-flex">
          <img
            src={values[name]}
            alt="Profile"
            style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "100%" }}
          />
          <button
            type="button"
            className="border-0 p-0"
            onClick={handleRemoveFile}
            style={{ background: "transparent", cursor: "pointer" }}
          >
            <RemoveIcon />
          </button>
        </div>
      )}
      {(meta.touched && meta.error) || customError ? (
        <div className="error">{meta.error || customError}</div>
      ) : null}
    </>
  );
};

export default AppProfilePictureField;
